enum Page {
  BEACON_LOGIN__INPUT = 'Beacon-login_input',
  BEACON_LOGIN_SUCCESS = 'Beacon-login-success',
  BULK_CAPTURE_INVITE = 'Bulk-capture-invite',
  SIGNUP_PROFESSIONAL_ACTIVATE__INPUT = 'Activate_input',
  DESIGN_ORDERS = 'Design-orders',
  DESIGN_ORDERS_SUMMARY = 'Design-orders-summary',
  DESIGN_ORDERS_HOMEOWNER = 'Design-orders-homeower',
  DESIGN_ORDERS_HOMEOWNER_EDIT = 'Design-orders-homeower-edit',
  DESIGN_ORDERS_HOMEOWNER_EDIT_STEP = 'Design-orders-homeower-edit-step',
  DESIGN_ORDERS_HOMEOWNER_EDIT_SUMMARY = 'Design-orders-homeower-edit-summary',
  DESIGN_ORDERS_HOMEOWNER_EDIT_END = 'Design-orders-homeower-edit-end',
  DESIGN_ORDERS_HOMEOWNER_REQUEST = 'Design-orders-homeower-request',
  DESIGN_ORDERS_HOMEOWNER_REQUEST_STEP = 'Design-orders-homeower-request-step',
  DESIGN_ORDERS_HOMEOWNER_REQUEST_SUMMARY = 'Design-orders-homeower-request-summary',
  DESIGN_ORDERS_HOMEOWNER_REQUEST_END = 'Design-orders-homeower-request-end',
  DESIGN_ORDERS_PRO = 'Design-orders-pro',
  DESIGN_ORDERS_PRO_EDIT = 'Design-orders-pro-edit',
  DESIGN_ORDERS_PRO_REQUEST = 'Design-orders-pro-request',
  DESIGN_ORDERS_PRO_REQUEST_STEP = 'Design-orders-pro-request-step',
  DESIGN_ORDERS_PRO_EDIT_STEP = 'Design-orders-pro-edit-step',
  DESIGN_ORDERS_PRO_REQUEST_INTRO = 'Design-orders-pro-request-intro',
  DESIGN_ORDERS_PRO_REQUEST_SUMMARY = 'Design-orders-pro-request-summary',
  DESIGN_ORDERS_PRO_EDIT_SUMMARY = 'Design-orders-pro-edit-summary',
  DESIGN_ORDERS_PRO_EDIT_END = 'Design-orders-pro-edit-end',
  DESIGN_ORDERS_PRO_REQUEST_END = 'Design-orders-pro-request-end',
  DESIGN_STUDIO_SHARE_VIEW = 'Design-studio-share-view',
  DESIGN_STUDIO_PRO_VIEW = 'Design-studio-pro-view',
  DESIGN_STUDIO = 'Design-studio',
  DESIGN_PRO = 'Design-pro',
  COMPLETE_PROFILE__INPUT = 'Complete-profile_input',
  SURVEY_PROFILE__INPUT = 'Survey-profile_input',
  FORGOT_PASSWORD__INPUT = 'Forgot-password_input',
  HOMEOWNER_ACCOUNT__INPUT = 'Homeowner-account_input',
  HOMEOWNER_DOWNLOAD_SENT = 'Homeowner-download-sent',
  HOMEOWNER_DOWNLOAD__INPUT = 'Homeowner-download_input',
  INSURANCE_ACCOUNT__INPUT = 'Insurance-account_input',
  INSURANCE_COMPLETE_PROFILE__INPUT = 'Insurance-complete-profile_input',
  INSURANCE_SURVEY_PROFILE__INPUT = 'Insurance-survey-profile_input',
  LOGIN__INPUT = 'Login_input',
  NOT_FOUND = 'Not-found',
  PASSWORD_EMAIL_SENT = 'Password-email-sent',
  PROFESSIONAL_ACCOUNT__INPUT = 'Professional-account_input',
  RENDERINGS_HUB = 'Renderings-hub',
  RENDERINGS_SHARED = 'Renderings-shared',
  RENDERINGS_USER_ACTIVATE = 'Renderings-user-activate',
  RENDERINGS_INTERACTIVE = 'Renderings-interactive',
  PROFESSIONAL_ACCOUNT_PROMOTION__INPUT = 'Professional-account_input',
  RESET_PASSWORD_ERROR__INPUT = 'Reset-password-error_input',
  RESET_PASSWORD_SUCCESS = 'Reset-password-success',
  RESET_PASSWORD__INPUT = 'Reset-password_input',
  SIGNUP__FORK = 'Signup_fork',
  SIGNUP_MOBILE = 'Signup-mobile',
  SOMETHING_WRONG = 'Something-wrong',
  SSO_COMPLETE_PROFILE__INPUT = 'SSO-complete-profile_input',
  SSO_EMAIL__INPUT = 'SSO-email_input',
  SSO_LOGIN_FAILURE = 'SSO-login-failure',
  SSO_LOGIN_SUCCESS = 'SSO-login-success',
  SSO_LOGIN__INPUT = 'SSO-login_input',
  SSO_SIGNING_ON = 'SSO-signing-on',
  SSO_USERNAME__INPUT = 'SSO-username_input',
  TERMS_OF_SERVICE = 'Terms-of-service',
  UPGRADE__INPUT = 'Upgrade-account_input',
  PROPERTY_DETAILS = 'Property-details',
  DISCOVERABILITY_TABS = 'Discoverability tabs',
  INSPIRATION = 'Inspiration',
  INSPIRE_ME = 'Inspire_me',
  INSPIRE_ME_SHARE = 'Inspire_me_share',
  NEW_CONSTRUCTION_UPLOAD = 'New-construction-upload',
  MANAGE_TEAMS = 'Manage-teams',
  VIRTUAL_WALKTHROUGH = 'Virtual-walkthrough',
  PROPERTY_DETAILS_EXPORT_MODAL = 'Property-details-export-modal',
  INSPECTION = 'inspection',
  PAINT_MEASUREMENTS = 'paint-report',
  PAINT_MEASUREMENTS_SHARED = 'paint-report-shared',
  HOMEOWNER_MEASUREMENTS = 'homeowner-measurement-report',
  PROPERTIES = 'Properties',
  GROUPS = 'Groups',
  EMBED = 'Embed',
  PRO_LANDING_PAGE = 'Pro-landing-page',
  HOMEOWNER_APP_HOME = 'homeowner-app-home',
  HOMEOWNER_APP_INTERSTITIAL_THREE_D_FUSION = 'homeowner-app-interstitial-three-d-fusion',
  HOMEOWNER_APP_SAVED = 'homeowner-app-saved',
  HOMEOWNER_APP_SAVED__DETAIL = 'homeowner-app-saved_detail',
  HOMEOWNER_APP_SHARE = 'homeowner-app-share',
  HOMEOWNER_APP_PAINT_WALLS = 'homeowner-app-paint-walls',
  HOMEOWNER_APP_PROJECT = 'homeowner-app-project',
  HOMEOWNER_APP_PROJECT_DETAIL = 'homeowner-app-project-detail',
  HOMEOWNER_APP_PROJECTS_LIST = 'homeowner-app-projects-list',
  HOMEOWNER_APP_NEW_PROJECT = 'homeowner-app-new-project',
  HOMEOWNER_APP_PROJECT_IDEAS = 'homeowner-app-project-ideas',
  HOMEOWNER_APP_ORIGINAL = 'homeowner-app-original',
  HOMEOWNER_APP_ORIGINAL__DETAIL = 'homeowner-app-original_detail',
  HOMEOWNER_APP_ORIGINAL_GENERATED__DETAIL = 'homeowner-app-original-generated_detail',
  HOMEOWNER_APP_CUSTOMIZE = 'homeowner-app-customize',
  HOMEOWNER_APP_CUSTOMIZE__INSPIRE = 'homeowner-app-customize-inspire',
  SIGN_UP_ONBOARDING = 'sign-up-onboarding',
  LEAD_LANDING_PAGE = 'lead-landing-page',
  START = 'start',
  DESIGNER_LANDING_PAGE = 'designer-landing-page',
  WEB_UPLOAD = 'web-upload',
}

enum Global {
  NAV = 'nav-bar',
}

export { Page, Global };
